export default "__VITE_ASSET__957131f2__"